import React from "react";
import "./index.scss";

interface Props {
  saved?: boolean;
  onClick?: Function;
}

const SaveButton = (props) => {
  const { saved = false, onClick = () => {} } = props;

  return (
    <button
      className={saved ? "bookmark-button--saved" : "bookmark-button"}
      onClick={onClick}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.74998 1.08334H3.24998C3.10632 1.08334 2.96855 1.1404 2.86696 1.24199C2.76538 1.34357 2.70831 1.48134 2.70831 1.625V11.375C2.70831 11.4785 2.73798 11.5799 2.79382 11.6671C2.84966 11.7543 2.92932 11.8237 3.02337 11.867C3.11742 11.9103 3.22191 11.9258 3.32448 11.9116C3.42704 11.8973 3.52337 11.854 3.60206 11.7867L6.49998 9.35459L9.3654 11.7596C9.41601 11.8098 9.47604 11.8495 9.54203 11.8765C9.60803 11.9034 9.67869 11.9171 9.74998 11.9167C9.82104 11.9185 9.89153 11.9037 9.95581 11.8733C10.0547 11.8327 10.1394 11.7637 10.1992 11.675C10.2589 11.5863 10.2911 11.4819 10.2916 11.375V1.625C10.2916 1.48134 10.2346 1.34357 10.133 1.24199C10.0314 1.1404 9.89364 1.08334 9.74998 1.08334ZM9.20831 10.2158L6.84665 8.23334C6.74932 8.15227 6.62665 8.10787 6.49998 8.10787C6.37331 8.10787 6.25064 8.15227 6.15331 8.23334L3.79165 10.2158V2.16667H9.20831V10.2158Z"
          fill={saved ? "#FFFFFF" : "#FF1D58"}
        />
      </svg>
    </button>
  );
};

export default SaveButton;
